export const SHELF_SORTS = ["activity", "published", "players", "newest", "name"] as const;
export const SHELF_FILTER_VALUES = ["live", "development", "not-live", "not-built"] as const;

export interface ShelfSearch {
  sort?: Exclude<(typeof SHELF_SORTS)[number], "activity">;
  filter?: (typeof SHELF_FILTER_VALUES)[number];
  q?: string;
}

const MAX_Q = 100;

/** The router JSON-parses values, so a search for "2" or "true" arrives as a number or boolean. */
function text(value: unknown): string {
  if (typeof value === "string") return value;
  if (typeof value === "number" && Number.isFinite(value)) return String(value);
  if (typeof value === "boolean") return String(value);
  return "";
}

/** Keeps only what differs from the default view, so `/orgs/x` is the default. */
export function validateShelfSearch(raw: Record<string, unknown>): ShelfSearch {
  // Explicit undefined: the router merges the parent's raw search over a validated one, so an omitted key would leak.
  const out: ShelfSearch = { sort: undefined, filter: undefined, q: undefined };
  const sort = SHELF_SORTS.find((s) => s !== "activity" && s === raw.sort);
  if (sort && sort !== "activity") out.sort = sort;
  const filter = SHELF_FILTER_VALUES.find((f) => f === raw.filter);
  if (filter) out.filter = filter;
  const q = text(raw.q);
  if (q.trim() !== "") out.q = q.slice(0, MAX_Q);
  return out;
}
